<template>
  <v-row v-if="users.length > 0" class="scroll">
    <v-col v-if="showLabel" cols="12">
      Filter users:
    </v-col>
    <v-col cols="12">
      <v-text-field class="bg-white" v-model="usersSearch" label="Type to begin filtering..." clearable @click:clear="clearSearch" density="compact" variant="outlined" hide-details />
    </v-col>

    <v-col cols="12" class="py-0">
      <v-checkbox v-model="checkAllUsers" label="Select All" @change="checkAll(checkAllUsers)" density="compact" hide-details />
    </v-col>

    <v-col cols="12" v-if="showIncludeDeletedUsers">
      <v-checkbox v-model="deletedUsers" label="Include Deleted Users" @change="!!deletedUsers" density="compact" hide-details />
    </v-col>

    <v-col v-for="(user) in filteredUsers" v-bind="userColProps" cols="12" class="py-0">
      <v-checkbox v-model="selectedUsersData" :value="user['userId']" density="compact" hide-details>
        <template v-slot:label>
          <p v-if="selectedUsersData.includes(user['userId'])" style="font-weight: 600">
            {{ getUserName(user['username']) }}
          </p>
          <p v-else>
            {{ getUserName(user['username']) }}
          </p>
          <v-icon v-if="row > 1" class="mx-1" size="small" icon="mdi-pencil-box-outline"  @click.prevent="router.push({name: 'account.user.edit', params: { userId: user['userId'] }})"  />
        </template>
      </v-checkbox>
    </v-col>
  </v-row>

  <div v-else class="text-center">No Users to choose from.</div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useRouter } from "vue-router";

const props = defineProps({
  users: Array,
  usersSearchText: String,
  selectAll: Boolean,
  deletedUsers: Boolean,
  showIncludeDeletedUsers: Boolean,
  row: Number,
  prefix: String,
  modelValue: Array,
  showLabel: { type: Boolean, default: true }
});
const emit = defineEmits(['update:modelValue']);
const usersSearch = ref(props.usersSearchText);
const checkAllUsers = ref(props.selectAll);
const deletedUsers = ref(props.deletedUsers);
const selectedUsersData = ref(props.modelValue);
const router = useRouter();
const valueProps = ref(props.modelValue);

const userColProps = computed(() => {
  const cols = props.row === 1 ? 12 : Math.round(12 / props.row);
  return { cols: 12, md: cols };
});

const filteredUsers = computed(() => props.users.filter(user => user['username'].toLowerCase().includes(usersSearch.value?.toLowerCase())));

const checkAll = (status) => {
  checkAllUsers.value = status;
  selectedUsersData.value = status ? props.users.map(user => user['userId']) : [];
};

const getUserName = (name) => name.length > 29 ? `${name.substring(0, 29)}...` : name;

watch(usersSearch, () => {
  checkAllUsers.value = selectedUsersData.value.length === props.users.length;
});

watch(selectedUsersData, () => {
  checkAllUsers.value = selectedUsersData.value.length === props.users.length;
  emit('update:modelValue', selectedUsersData.value);
},{ deep: true });

function clearSearch() {
  usersSearch.value = '';
  checkAllUsers.value = valueProps.value.length === props.users.length;
}

</script>


<style scoped lang="scss">
.scroll {
  overflow-y: auto;
  max-height: 400px;
}
</style>
